// eslint-disable-next-line @trello/disallow-filenames
import React, { FunctionComponent, useCallback } from 'react';
import {
  SmartLink,
  SmartLinkAnalyticsContextType,
} from 'app/src/components/SmartMedia';
import type { SmartCardAppearance } from '@trello/smart-card';

interface SmartLinksBridgeProps {
  url: string;
  appearance: SmartCardAppearance | null;
  analyticsContext: SmartLinkAnalyticsContextType;
}

export const SmartLinksBridge: FunctionComponent<SmartLinksBridgeProps> = ({
  url,
  appearance,
  analyticsContext,
}) => {
  const plainLink = useCallback(() => <a href={url}>{url}</a>, [url]);
  return (
    <SmartLink
      url={url}
      appearance={appearance}
      plainLink={plainLink}
      analyticsContext={analyticsContext}
    />
  );
};
